import globalConf from '../../utiles/globalConfig';
import { getPlatform } from '../../utiles/device';
import { getPwaActivityScidAndCid } from '../../utiles/pwa';
import { updateObjScidAndCidOnStoreResult } from '../../utiles/storeHandleCid';
import { getGlobalGetLinkParams } from '@utiles/globalGetLink';
export let professionName; // 业务标识
export let workName; // 各入口的配置标识
export let pageName; // 页面名（对用户来说）
export let eventName; // 事件名
export let eventKeyConf; // 事件相关配置

let prePageName, preEventName, preEventKeyConf;

export const updateProfessionName = name => {
  professionName = name;
};

export const updateWorkName = name => {
  workName = name;
};

export const updatePage = name => {
  prePageName = pageName;
  pageName = name;
};

const getMainHost = () => {
  if (window.location.hostname == 'localhost') {
    return '37games.com';
  }
  let hostArr = window.location.hostname.split('.');
  let mainArr = hostArr.slice(-2);
  return mainArr.join('.');
};

// 旧逻辑
// const pushUrl = '//datain.octlib.com/api/v1/hw/common/event/collect';
// const id = 11;
// const apikey = '72e0e1c0-51e3-45ab-9b36-bf3b82143d9d';

// 新逻辑：兼容omnionverse平台
const apiMap = {
  'omnionverse.com':
    '//datain.omnionverse.com/api/v1/platform/common/event/collect?apikey=fb92c77d9c047e07b96b620304de6089%&id=11',
  other:
    '//datain.octlib.com/api/v1/hw/common/event/collect?apikey=72e0e1c0-51e3-45ab-9b36-bf3b82143d9d&id=11'
};
const mainHost = getMainHost();
const pushUrl = apiMap.hasOwnProperty(mainHost)
  ? apiMap[mainHost]
  : apiMap['other'];

const paramsObj = globalConf.getHrefParamObj();
let defaultData = {
  loginAccount: paramsObj.loginAccount || '',
  gameID: paramsObj.gameId || paramsObj.gameID || paramsObj.game_id || '',
  idfa: paramsObj.idfa || '',
  imei: paramsObj.imei || '',
  gameServerID: paramsObj.serverId || paramsObj.server_id || '',
  deviceCode: paramsObj.deviceCode || '',
  phoneModel: paramsObj.phoneModel || '',
  deviceForm: getPlatform(),
  ext11: paramsObj.cid || 0,
  ext12: paramsObj.scid || '',
  ext13: paramsObj.roleId || paramsObj['role_id'] || '',
  ext14: paramsObj.userId || paramsObj.userID || '',
  ext15: encodeURIComponent(document.referrer) || '',
  ext16: window.location.pathname,
  ext17: window.location.host,
  ext18: encodeURIComponent(navigator.userAgent) || '',
  ext19: paramsObj.sdkToken ? 'sdk' : paramsObj.pageSource || 'web',
  ext20: '2021-09-01',
  ext2: JSON.stringify(paramsObj), // 超长字段
  ext1: encodeURIComponent(window.location.href), // 超长字段
  ...getGlobalGetLinkParams()
};

const _formateUrl = (fname, pname, ename, value) => {
  let readyData = {
    event: ename,
    ext4: fname,
    ext5: pname,
    ext6: new Date().getTime(),
    ext8: value || '',
    ...defaultData
  };
  // 针对储值页的处理
  if (fname === 'global-pay') {
    let extData = getPwaActivityScidAndCid();
    readyData = updateObjScidAndCidOnStoreResult(readyData);
    readyData.ext11 = extData.cid || readyData.ext11;
    readyData.ext12 = extData.scid || readyData.ext12;
  }
  let dataStr = '';
  Object.keys(readyData || {}).map(item => {
    dataStr += `&${item}=${readyData[item]}`;
  });
  return `${pushUrl}${dataStr}`;
};

export const updateParam = (name, value) => {
  defaultData[name] = value;
};

export const emitUpload = (name, keyConf, value) => {
  if (!name) return;
  preEventName = eventName;
  eventName = name;

  preEventKeyConf = eventKeyConf;
  eventKeyConf = keyConf;

  // 离开页面事件上报
  if (eventName == 'leave-page') {
    if (preEventKeyConf && preEventKeyConf.newPage) {
      eventName = 'jump-page';
    }
  }
  if (keyConf && keyConf.pageName && keyConf.pageName !== pageName) {
    pageName = keyConf.pageName;
  }
  ((fname, pname, ename, value) => {
    // uploadSelf(fname, pname, ename, value);
    uploadGa(fname, pname, ename, value);
  })(
    professionName,
    (keyConf && keyConf.pageName) || pageName,
    eventName,
    value
  );
};

const uploadSelf = (fname, pname, ename, value) => {
  let img = document.createElement('img');
  img.src = _formateUrl(fname, pname, ename, value);
};

const uploadGa = (fname, pname, ename, value) => {
  try {
    gtag('event', ename, {
      pageName: pname,
      professionName: fname,
      loginAccount: defaultData.loginAccount,
      gameId: defaultData.gameID,
      pageSource: defaultData.ext19,
      version: defaultData.ext20,
      user_id: defaultData.loginAccount,
      cid: defaultData.ext11,
      scid: defaultData.ext12,
      customValue: value || ''
    });
    // window.dataLayer.push({
    //   event: ename,
    //   pageName: pname,
    //   professionName: fname,
    //   loginAccount: defaultData.loginAccount,
    //   gameId: defaultData.gameID,
    //   pageSource: defaultData.ext19,
    // });
  } catch (error) {
    console.error(error);
  }
};
